import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const getBreak = async (presenceId) => {
  const { data } = await SigliveServiceSSE({
    method: 'GET',
    url: `/monitoring-operator/break/detail?operatorPresenceId=${presenceId}`,
  });

  return data?.data;
};

export default getBreak;
